import styled from "styled-components";

export const MainWrapperDefaultBox = styled.div`
  position: relative;
  /** set a width. It actually doesn't matter ow much as long as it's less than 100% - sidebar_width
  It is important to set it so the flex has a base from where to start computing the remaining space: Explanations here: https://css-tricks.com/flex-grow-is-weird/
  Also, when missing, lists like orbit swiper with jackpot template and live tables creates problems by pushing the total width of the page */
  width: 80%;
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    width: calc(100% - env(safe-area-inset-right) - env(safe-area-inset-left));
  }
  flex: 1 1 auto;
  /** For devices with notch and/or with bar navigation (iPhones, iPads, probably also some Androids),
  the margins (left and right) need to be adjusted because of landscape problems - for any other devices, env() will return 0. */
  margin: 0 env(safe-area-inset-right) 0 env(safe-area-inset-left);
`;